import React from 'react'
import { Container } from 'react-bootstrap';
import insaurance from '../../../assets/images/main-home/insaurance.jpg';
import logistics from '../../../assets/images/main-home/logistics.jpg';
import security from '../../../assets/images/main-home/security.jpg';
import testing from '../../../assets/images/main-home/testing.jpg';
import warehouse from '../../../assets/images/main-home/warehouse.jpg';
import MultiLanguageTranslation from '../../../_components/Translate/MultiLangTranslate'
export default class extends React.Component{
    render(){
        return <section className="mainHome-servicesWrap">
        <Container fluid>
            <h2><MultiLanguageTranslation title={'Our comprehensive services that add value while simplifying everything for you.'}></MultiLanguageTranslation></h2>
            <div className="mainHome-servicesInner">
                <div className="mainHome-servicesbx">
                    <a href="/warehouse-management" >
                        <img src={warehouse} alt="" className="img-fluid" />
                    </a>
                    <a  href="/warehouse-management">
                    <MultiLanguageTranslation title={'Warehouse Management'}></MultiLanguageTranslation>
                    </a>
                </div>
                <div className="mainHome-servicesbx">
                    <a href="/quality-testing" >
                        <img src={testing} alt="" className="img-fluid"  />
                    </a>
                    <a href="/quality-testing">
                    <MultiLanguageTranslation title={'Quality Testing'}></MultiLanguageTranslation>
                    </a>
                </div>
                <div className="mainHome-servicesbx">
                    <a href="/logistic-handling" >
                        <img src={logistics} alt="" className="img-fluid" />
                    </a>
                    <a href="/logistic-handling">
                    <MultiLanguageTranslation title={'Logistics & Handling'}></MultiLanguageTranslation>
                    </a>
                </div>
                <div className="mainHome-servicesbx">
                    <a href="/warehouse-monitoring-system" >
                        <img src={security} alt="" className="img-fluid"/>
                    </a>
                    <a href="/warehouse-monitoring-system" >
                    <MultiLanguageTranslation title={'Security & Monitoring'}></MultiLanguageTranslation>
                    </a>
                </div>
                <div className="mainHome-servicesbx">
                    <a href="/insurance-solutions">
                        <img src={insaurance} alt="" className="img-fluid" />
                    </a>
                    <a href="/insurance-solutions">
                    <MultiLanguageTranslation title={'Insurance'}></MultiLanguageTranslation>
                    </a>
                </div>
            </div>
        </Container>
    </section>
    }
}